import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { BaseSiteService, Currency } from '@spartacus/core'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class BaseSiteUtilsService {

  constructor (protected baseSiteService: BaseSiteService) {
  }

  getCurrencyOfCountry (isocode?: string) {
    return this.baseSiteService.getAll().pipe(
      map(baseSites => baseSites?.find(base => isocode ? base?.country?.isocode === isocode : base?.fallback)),
      map(baseSite => baseSite?.currency))
  }
}
